import React from 'react';
import styled from 'styled-components';
import Section from './shared/Section';
import { Paragraph, TextLine } from './shared/Basics.js';

const TextLineEmphasis = styled(TextLine)`
  letter-spacing: 2px;
`;



const Location = () => {
  return (
    <>
      <Section title='Location' id='location'>
        <Paragraph>Come join us for a timeless celebration of love.</Paragraph>
        <Paragraph>
          <TextLineEmphasis>Casa Real at Ruby Hill Winery</TextLineEmphasis>
          <TextLineEmphasis>410 Vineyard Ave,</TextLineEmphasis>
          <TextLineEmphasis>Pleasanton, CA 94566</TextLineEmphasis>
        </Paragraph>
        <Paragraph><a href="https://goo.gl/maps/qoCfZd2z1xdyAX7b7">Google Maps.</a></Paragraph>
      </Section>
      <Section title='Zoom Live Stream Link' id='stream'>
        <Paragraph>For those of you who cannot make it, come join us on Zoom!</Paragraph>
        <Paragraph>
          <TextLineEmphasis>Meeting ID:</TextLineEmphasis>  
          <TextLineEmphasis>891 8837 7480</TextLineEmphasis>
        </Paragraph>
        <Paragraph>
          <TextLineEmphasis>Passcode:</TextLineEmphasis>  
          <TextLineEmphasis>983276</TextLineEmphasis>  
        </Paragraph>
        <Paragraph>
          <a href="https://us02web.zoom.us/j/89188377480?pwd=N1Zmak04WWE3c2xwcGdHZGt6RWtGdz09">
            https://us02web.zoom.us/j/89188377480?pwd=N1Zmak04WWE3c2xwcGdHZGt6RWtGdz09
          </a>
        </Paragraph>
      </Section>
    </>
  );
}

export default Location;
